import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import About from '@/pages/About'
import Schools from '@/pages/Schools'
import Introduction from '@/pages/Introduction'
import Blog from '@/pages/BlogHome'
import BlogDetails from '@/pages/BlogDetails'
import SchoolDetails from '@/pages/SchoolDetails'
import Collaboration from '@/pages/Collaboration'
import JobSingle from '@/pages/JobSingle'
import PricingPlan from '@/pages/PricingPlan'
import Elements from '@/pages/Elements'
import CollaborationDetails from '@/pages/collaborationDetails'
import UniversitiDetails from '@/pages/universitiDetails'
import InternationalDetails from '@/pages/InternationalDetails'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/introduction',
      name: 'introduction',
      component: Introduction
    },
    {
      path: '/blog',
      name: 'blog',
      component: Blog
    },
    {
      path: '/blogDetails',
      name: 'blogDetails',
      component: BlogDetails
    },
    {
      path: '/schools',
      name: 'schools',
      component: Schools
    },
    {
      path: '/collaboration',
      name: 'collaboration',
      component: Collaboration
    },
    {
      path: '/jobSingle',
      name: 'jobSingle',
      component: JobSingle
    },
    {
      path: '/pricingPlan',
      name: 'pricingPlan',
      component: PricingPlan
    },
    {
      path: '/elements',
      name: 'elements',
      component: Elements
    },
    {
      path: '/schoolDetails',
      name: 'schoolDetails',
      component: SchoolDetails
    },
    {
      path: '/collaborationDetails',
      name: 'collaborationDetails',
      component: CollaborationDetails
    },
    {
      path: '/universitiDetails',
      name: 'universitiDetails',
      component: UniversitiDetails
    }, {
      path: '/internationalDetails',
      name: 'internationalDetails',
      component: InternationalDetails
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js